import ".././styles/Memberships.css";
import adminlogo from ".././assets/svgs/admin.svg";
import maintenencelogo from ".././assets/svgs/maintenance.svg";
import organizinglogo from ".././assets/svgs/calendar-19-svgrepo-com.svg";
import forumlogo from ".././assets/svgs/forums.svg";
import programslogo from ".././assets/svgs/programs.svg";
import campaignlogo from ".././assets/svgs/announce-svgrepo-com.svg";

const BENEFITS = [
  "Voice in PCCM governance: vote, nominate, or run for the Governing Board.",
  "Preferred rates on Boardroom/Multi-Purpose Room and selected community events.",
  "Stay connected through programs, forums, and cultural events.",
  "Support PCCM’s mission, objectives, and core values.",
];

const CATEGORIES = [
  { icon: adminlogo, title: "Administrative Support Services" },
  { icon: campaignlogo, title: "Membership Campaign" },
  { icon: maintenencelogo, title: "Building Upkeep & Maintenance" },
  { icon: organizinglogo, title: "Social & Fundraising Events" },
  { icon: programslogo, title: "Programs & Services Development" },
  { icon: forumlogo, title: "Forums & Information Sessions" },
];

const REQUIREMENTS = [
  "At least 18 years old.",
  "Ancestral origin from the Philippines.",
  "Canadian Citizen or Permanent Resident in Canada.",
  "Resident of Manitoba.",
  "Annual fee: $15 (free for seniors 65+, per Article 3.2 (IV) of the PCCM Constitution & By-Laws).",
  "Not suspended/expelled/resigned (Article 3.5 (e)).",
  "Provide one valid photo ID for verification.",
];

function Memberships() {
  return (
    <div className="memberships-page">
      <div className="page-header membership-hero">
        <div className="overlay"></div>
        <div className="container header-content">
          <h1>Memberships</h1>
          <p>Be part of PCCM’s mission and shape our community’s future.</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="membership-grid">
            <div className="card">
              <div className="card-content">
                <h3>Why join PCCM?</h3>
                <p className="text-muted">
                  Membership is open to individuals of Filipino descent with residency in Manitoba.
                </p>
                <ul className="benefits-list">
                  {BENEFITS.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="card highlight-card">
              <div className="card-content">
                <h3>Member pathways</h3>
                <p className="text-muted">Choose where you’d like to contribute:</p>
                <div className="category-grid">
                  {CATEGORIES.map((c) => (
                    <div key={c.title} className="category-card">
                      <img src={c.icon} alt={c.title} className="category-icon" />
                      <p>{c.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <div className="card">
            <div className="card-content">
              <h3>Membership requirements</h3>
              <p className="text-muted">Have these ready before submitting your form:</p>
              <ul className="requirements-list">
                {REQUIREMENTS.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="card form-card">
            <div className="card-content">
              <div className="form-header">
                <div>
                  <h3>Apply online</h3>
                  <p className="text-muted">
                    Fill out the membership form. We’ll confirm eligibility and next steps.
                  </p>
                </div>
                <div className="form-steps">
                  <span className="pill">Step 1: Complete form</span>
                  <span className="pill">Step 2: Verify ID</span>
                  <span className="pill">Step 3: Pay fee (if applicable)</span>
                </div>
              </div>
              <div className="iframe-wrap">
                <iframe
                  id="membership-fields"
                  src="https://forms.fillout.com/t/3CuSidyTUdus"
                  width="100%"
                  height="900"
                  frameBorder="0"
                  marginHeight="0"
                  marginWidth="0"
                  title="PCCM Membership Form"
                >
                  Loading…
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Memberships;
